// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__3wbH8","radioRow":"SimpleQuestionBuilderModal_radioRow__aLNrv"};